import React from 'react';
import { Property, AppUser } from '../../../types';
import { PropertiesTable } from '../PropertiesTable';
import { PaginationControls } from '../PaginationControls';
import { MapResultsView } from '../../../views/broker/MapResultsView';
import { UseBulkSelectionReturn } from '../../../hooks/useBulkSelection';

interface BrokerResultsViewContentProps {
  viewMode: 'grid' | 'map';
  isSelectionMode: boolean;
  propertiesData: any;
  bulkSelection: UseBulkSelectionReturn;
  appUser: AppUser | null;
  spatialFilter: any;
  onSpatialFilterChange: (filter: any) => void;
  inmobiliariasConfig: Record<string, any>;
  filterInput?: any;
  onSelectPropertyDetail: (p: Property) => void;
  onSelectPropertyToShare: (p: Property) => void;
  onSelectInterested: (p: Property) => void;
}

export const BrokerResultsViewContent: React.FC<BrokerResultsViewContentProps> = ({
  viewMode,
  isSelectionMode,
  propertiesData,
  bulkSelection,
  appUser,
  spatialFilter,
  onSpatialFilterChange,
  inmobiliariasConfig,
  filterInput,
  onSelectPropertyDetail,
  onSelectPropertyToShare,
  onSelectInterested,
}) => {
  if (viewMode === 'grid' || isSelectionMode) {
    return (
      <>
        <PropertiesTable
          properties={propertiesData.properties}
          isLoading={propertiesData.isLoadingProperties}
          onViewProperty={onSelectPropertyDetail}
          onShareProperty={onSelectPropertyToShare}
          selectedPropertiesForCsv={bulkSelection.selectedIds}
          onToggleSelectPropertyForCsv={bulkSelection.toggleSelectProperty}
          onToggleSelectAllForCsv={bulkSelection.toggleSelectAll}
          totalMatchingPropertiesCount={propertiesData.totalMatchingPropertiesCount}
          isProcessingSelectAll={propertiesData.isLoadingProperties && isSelectionMode}
          fetchPropertiesError={propertiesData.fetchPropertiesError}
          appUser={appUser}
          onInterested={onSelectInterested}
          isSelectionModeActive={isSelectionMode}
          inmobiliariasConfig={inmobiliariasConfig}
          isPropertySelectedFn={bulkSelection.isPropertySelected}
          isAllSelected={bulkSelection.isAllSelected}
          selectedCount={bulkSelection.selectedCount}
        />
        <PaginationControls
          currentPage={propertiesData.currentPage}
          totalPages={propertiesData.totalPages}
          onPageChange={(p) => propertiesData.handlePageChange(p)}
        />
      </>
    );
  }

  return (
    <MapResultsView
      paginatedProperties={propertiesData.properties}
      allFilteredProperties={propertiesData.allMatchingProperties}
      isLoading={propertiesData.isLoadingProperties}
      onViewProperty={onSelectPropertyDetail}
      onShareProperty={onSelectPropertyToShare}
      spatialFilter={spatialFilter}
      onSpatialFilterChange={onSpatialFilterChange}
      currentSelectedPropertiesForCsv={bulkSelection.selectedIds}
      onToggleSelectPropertyForCsv={bulkSelection.toggleSelectProperty}
      appUser={appUser}
      onInterested={onSelectInterested}
      currentPage={propertiesData.currentPage}
      totalPages={propertiesData.totalPages}
      onPageChange={(p) => propertiesData.handlePageChange(p)}
      inmobiliariasConfig={inmobiliariasConfig}
      filterInput={filterInput}
    />
  );
};
